var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("c-input", {
        ref: "date",
        attrs: {
          type: "date",
          placeholder: "00.00.0000",
          label: _vm.field.name,
          icon: "calendar",
          selects: _vm.selects,
          clearable: true,
          editable: true,
          "icon-right": true,
          "required-mark": _vm.field.required,
          required: _vm.error,
          "required-message": _vm.error,
          "default-year": 2000,
        },
        model: {
          value: _vm.localValue,
          callback: function ($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }